module.exports = __webpack_public_path__ + "media/images/landing/we_believe_1-25a6bbffeef881560caa129f6cc5d6c3.png";